import React from "react";
import {withCommands} from "./index";
import AsyncSelect from "react-select/lib/Async";
import apiClient from "../../../../services/session/apiClient"



export const AccountSelector = withCommands(({
                                        selected,
                                        commands,
                                        onSelected
                                      }) => {
  return (<div className="control-group">
    <label>Accounts</label>
    <AsyncSelect
      value={selected}
      autoload={false}
      loadOptions={(input, cb) =>
        apiClient.get('/manageTool/accounts', {
          params: { q: input }
        })
          .then(resp => {
            let mapped = resp.data.map(x => ({label: `${x.name} (${x.billingAccountName})`, value: x.accountId}));
            cb(mapped)
          })
      }
      isMulti
      onChange={(opt) => onSelected && onSelected(opt)}
    />
  </div>)
})

export const ProviderSelector = withCommands(({
                                         selected,
                                         commands,
                                         onSelected
                                       }) => {
  return (<div className="control-group">
    <label>Provider</label>
    <AsyncSelect
      value={selected}
      clearable={false}
      loadOptions={(input, cb) =>
        apiClient.get('/manageTool/providers')
          .then(resp => {
            let mapped = resp.data.filter(x => x.displayName.toLowerCase().indexOf(input.toLowerCase()) > -1).map(x => ({label: x.displayName, value: x.id}))
            cb(mapped)
          })
      }
      onChange={opt => onSelected && onSelected(opt)}
    />
  </div>)
})


export const UserSelector = withCommands(
({
  selected, commands, onSelected
}) => {

  return (
    <div className="control-group">
      <label>Users</label>
      <AsyncSelect
        value={selected}
        isMulti
        autoload={false}
        loadOptions={(input, cb) =>
          apiClient.get('/manageTool/users', { params: {q: input}})
            .then(resp => {
              const mapped = resp.data.map(user => ({
                label: `${user.username} (${user.userType})`,
                value: user.userId
              }))
              cb(mapped)
            })
        }
        onChange={selections => {
          onSelected && onSelected(selections)
        }}
        />
    </div>
    )
})

export const LocationSelector = withCommands(
  ({
    selected, commands, onSelected
  }) => {
    return (
      <div className="control-group">
        <label>Locations</label>
        <AsyncSelect
          autoload={false}
          ignoreCase={false}
          value={selected}
          isMulti
          searchPromptText={"Type to search. (Case sensitive, starts with)"}
          loadOptions={(input, cb) => {
            if (!input || !input.trim()) {
              cb([])
            } else {
              apiClient.get('/manageTool/locations', {params: {q: input}})
                .then(resp => {
                  const mapped = resp.data.map(location => ({
                    label: `${location.businessName} - ${location.locationId} (${location.address}) ${location.isCompetitor ? '[COMPETITOR]' : []}`,
                    value: location.locationId
                  }))
                  cb(mapped)
                })
            }
          }}
          onChange={opts => onSelected && onSelected(opts)}
        />
      </div>
    )
  }
)

export const BillingAccountSelector = withCommands(({
                                               selected,
                                               commands,
                                               onSelected
                                             }) => {
  return (<div className="control-group">
    <label>Billing Accounts</label>
    <AsyncSelect
      value={selected}
      autoload={false}
      isMulti
      loadOptions={(input, cb) =>
        apiClient.get('/manageTool/billingAccounts', {
          params: { q: input }
        })
          .then(resp => {
            let mapped = resp.data.map(x => ({label: `${x.name}`, value: x.billingAccountId}));
            cb(mapped)
          })
      }
      onChange={(opt) => onSelected && onSelected(opt)}
    />
  </div>)
})

export const CredentialSelector = withCommands(({
                                               selected,
                                               commands,
                                               onSelected
                                             }) => {
  return (<div className="control-group">
    <label>Credential ID</label>
    <AsyncSelect
      value={selected}
      autoload={false}
      isMulti
      loadOptions={(input, cb) =>
        apiClient.get('/manageTool/credentials', {
          params: { q: input }
        })
          .then(resp => {
            let mapped = resp.data.map(x => ({label: `${x.name}`, value: x.credentialId}));
            cb(mapped)
          })
      }
      onChange={(opt) => onSelected && onSelected(opt)}
    />
  </div>)
})
